import React from 'react';
import styles from './styles/styles.module.scss';
import AlgoliaSearchBox from '../../AlgoliaSearchBox';
import FilterBar from '../FilterBar';
import MobileExploreMapSwitch from '../../MobileExploreMapSwitch';
import GlobalFiltersModal from '../GlobalFiltersModal';
import { StringConstantsMixin } from '../../../application/javascripts/react_components/mixins/shared/string_constants_mixin';

class SearchFilterBar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  // Note: Had to add this 'enabledKey' here because the props.enabledFilters keys don't necessarily match the filter keys...
  getMappedFilters = () => {
    const pageStrings = StringConstantsMixin.strings.FILTERS;
    return {
      mappedFilters: [
        {
          display: pageStrings.DIFFICULTY,
          key: 'difficulty',
          enabledKey: 'difficulty',
          type: 'checkbox',
          nested: false,
          config: this.props.filters.difficulty
        },
        {
          display: pageStrings.LENGTH,
          key: 'lengths',
          enabledKey: 'length',
          type: 'slider',
          nested: false,
          config: this.props.filters.lengths
        },
        {
          display: pageStrings.ELEV_GAIN,
          key: 'elevation_gain',
          enabledKey: 'elevation_gain',
          type: 'slider',
          nested: false,
          config: this.props.filters.elevation_gain
        },
        {
          display: pageStrings.TIME,
          key: 'time_duration',
          enabledKey: 'time_duration',
          type: 'slider',
          nested: false,
          config: this.props.filters.time_duration
        },
        {
          display: pageStrings.ROUTE_TYPE,
          key: 'route_type',
          enabledKey: 'route_type',
          type: 'checkbox',
          nested: false,
          config: this.props.filters.route_type
        },
        {
          display: pageStrings.RATING,
          key: 'minRating',
          enabledKey: 'rating',
          type: 'rating',
          nested: false,
          config: this.props.filters.minRating
        },
        {
          display: pageStrings.SORT_LABEL,
          key: 'sort',
          enabledKey: 'sort',
          type: 'sort',
          nested: true,
          config: this.props.filters.sort
        },
        {
          display: pageStrings.ACTIVITY_LABEL,
          key: 'activities',
          enabledKey: 'activity',
          type: 'cloud',
          nested: true,
          truncate: true,
          config: this.props.filters.activities
        },
        {
          display: pageStrings.FEATURES_LABEL,
          key: 'features',
          enabledKey: 'feature',
          type: 'cloud',
          nested: true,
          truncate: true,
          config: this.props.filters.features
        },
        {
          display: pageStrings.SUITABILITY,
          key: 'access',
          enabledKey: 'access',
          type: 'cloud',
          nested: true,
          config: this.props.filters.access
        },
        {
          display: pageStrings.TRAIL_TRAFFIC,
          key: 'visitor_usage',
          enabledKey: 'visitor_usage',
          type: 'cloud',
          nested: true,
          config: this.props.filters.visitor_usage
        },
        {
          display: pageStrings.TRAIL_COMPLETION,
          key: 'completed',
          enabledKey: 'completed',
          type: 'cloud',
          nested: true,
          config: this.props.filters.completed
        },
        {
          display: 'Parks',
          key: 'areas',
          enabledKey: 'area',
          type: 'cloud',
          nested: false,
          admin: true,
          config: this.props.filters.areas
        },
        {
          display: 'City',
          key: 'cities',
          enabledKey: 'city',
          type: 'cloud',
          nested: false,
          admin: true,
          config: this.props.filters.cities
        },
        {
          display: 'State',
          key: 'states',
          enabledKey: 'state',
          type: 'cloud',
          nested: false,
          admin: true,
          config: this.props.filters.states
        },
        {
          display: 'Country',
          key: 'countries',
          enabledKey: 'country',
          type: 'cloud',
          nested: false,
          admin: true,
          config: this.props.filters.countries
        },
        {
          display: 'Linked',
          key: 'linked',
          enabledKey: 'linked',
          type: 'cloud',
          nested: false,
          admin: true,
          config: this.props.filters.linked
        }
      ]
    };
  };

  getMappedProps = () => {
    return { ...this.getMappedFilters(), ...this.props };
  };

  openFiltersModal = () => {
    this.setState({
      filtersModalOpen: true
    });
    $('body').css('overflow', 'hidden');
    $('.hide-for-fullscreen-modal').css('display', 'none');
  };

  closeFiltersModal = () => {
    this.setState({
      filtersModalOpen: false
    });
    $('body').css('overflow', 'unset');
    $('.hide-for-fullscreen-modal').css('display', '');
  };

  renderFiltersModal = () => {
    if (!this.state.filtersModalOpen) {
      return null;
    }

    return <GlobalFiltersModal handleClose={this.closeFiltersModal} {...this.props} />;
  };

  renderButtons = () => {
    return (
      <div className={styles.buttons}>
        <button className={styles.filtersButton} onClick={this.openFiltersModal} />
        <MobileExploreMapSwitch showMapMobile={this.props.filters.mobileMap} />
      </div>
    );
  };

  render() {
    const headerBarClass = `${styles.container} ${this.props.isMobileWidth ? 'hide-for-fullscreen-modal' : ''}`;
    return (
      <div>
        <div className={headerBarClass}>
          <AlgoliaSearchBox
            algoliaIndexId={this.props.context.primaryAlgoliaIndexId}
            className={styles.search}
            handleTrailSelect={this.props.handleTrailSelected}
            handleAreaSelect={this.props.handleObjectSelected}
            handleLocationSelect={this.props.handleObjectSelected}
            handleQueryStringSubmit={queryString => this.props.handleQueryTermSet(queryString.trim())}
            allowStringSearch={this.props.allowStringSearch}
            liveStringSearch={this.props.liveStringSearch}
            onSearchPage
            numResults={this.props.isMobileWidth ? 8 : 10}
            placeholderText={this.props.placeholderText}
            currentUser={this.props.context.currentUser}
            mobileBrowser={this.props.context.mobileBrowser}
            languageRegionCode={this.props.context.languageRegionCode}
            typeSubset={this.props.typeSubsets}
            defaultLatLng={this.props.defaultLatLng}
            listTrailIds={this.props.filters.trailIds}
            useNewSearchExperience={this.props.context.featureFlags.useNewSearchExperience}
            page="explore"
          />
          <div className={styles.filters}>
            <FilterBar {...this.getMappedProps()} />
          </div>
          {this.renderButtons()}
        </div>
        {this.renderFiltersModal()}
      </div>
    );
  }
}

export default SearchFilterBar;
